import { apiClient } from '@/shared/api';

import { getOnePageDataProps, Page } from '../config';

export async function getOnePageData(
  props: getOnePageDataProps,
): Promise<Page> {
  const { slug } = props;
  return await apiClient(`page/${slug}`);
}
